import styles from "./SkipContinueButton.module.css";
import {styleHelper} from "../../helpers/commonFunctions";
import {SkipContinueButtonDataType} from "../../interfaces/skipContinueButton/skipContinueButton.type";
import Button from "./Button";
import useAppStore from "../../store/AppStore";
const SkipContinueButton = ({ items }: { items: SkipContinueButtonDataType }) => {
    const skipButton = items?.skip;
    const continueButton = items?.continue;
    const {isDeviceMobile} = useAppStore();
    return (
        <div className={`vas-w-100 vas-px-3 ${isDeviceMobile ? 'vas-p-3' : ''} ${
            styles.sticky_container
        } 
      `} style={styleHelper({
            backgroundColor: items?.containerColor,
            position: isDeviceMobile ? "sticky" : "static",
        })}>
            <div className={`vas-flex-row vas-d-flex vas-w-100 vas-gap-2 justify-content-between`}>
                <Button colSize={`vas-w-25`} item={skipButton}></Button>
                <Button colSize={`vas-w-75`} item={continueButton}></Button>
            </div>
        </div>
    );
};

export default SkipContinueButton;
